import {
  buildDateFilterSpecs,
  buildNumberFilterSpecs,
  buildValueFilterSpec,
} from "./filterSpecUtils";

export const createEmptySpecification = (sourceTables) => ({
  sourceTables,
  sourceColumns: [],
  filters: [],
  order: [],
  outputColumns: [],
  aggregate: null,
  joins: null,
  group: null,
});

export const generateId = () =>
  `${Date.now()}-${Math.random().toString(36).slice(2, 9)}`;

export const toFrontendFilter = (filter, state = "saved") => ({
  _spec: filter,
  _id: generateId(),
  _type: "filter",
  _status: state,
  _timestamp: Date.now(),
});

export const toFrontendFilters = (filters, state = "saved") =>
  filters.map((f) => toFrontendFilter(f, state));

const toEditableFilters = (specs, state) =>
  specs.map((spec) => toFrontendFilter({ ...spec, editable: true }, state));

export const buildValueFilter = (column, values, state = "applied") => {
  if (values.size === 0) return [];
  return toEditableFilters([buildValueFilterSpec(column, values)], state);
};

export const buildBooleanFilter = (column, value, state = "applied") =>
  toEditableFilters(
    [buildValueFilterSpec(column, new Set([value]), true)],
    state
  );

export const buildDateFilter = (column, range, state = "applied") =>
  toEditableFilters(buildDateFilterSpecs(column, range), state);

export const buildNumberFilter = (column, range, state = "applied") =>
  toEditableFilters(buildNumberFilterSpecs(column, range), state);
